import { render, staticRenderFns } from "./map-items-selector.vue?vue&type=template&id=49b399a6&scoped=true"
import script from "./map-items-selector.vue?vue&type=script&lang=js"
export * from "./map-items-selector.vue?vue&type=script&lang=js"
import style0 from "./map-items-selector.vue?vue&type=style&index=0&id=49b399a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b399a6",
  null
  
)

export default component.exports